import Vue from 'vue'
import { Icon, Popup, Button, Field, Search, Picker, Tag, Collapse, CollapseItem } from 'vant'

Vue.use(Field)
Vue.use(Button)
Vue.use(Popup)
Vue.use(Icon)
Vue.use(Picker)
Vue.use(Search)
Vue.use(Tag)
Vue.use(Collapse)
Vue.use(CollapseItem)
